import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { snakeCaseToInitCase } from '@modernloop/shared/utils';
import { Alert, AlertTitle, Typography } from '@mui/material';

import { TrainingStatus } from 'src/generated/mloop-graphql';

type Props = { roleImpacted?: TrainingStatus | null };

const RoleChangeAlert: FC<Props> = ({ roleImpacted }) => {
  const { t } = useTranslation();
  if (!roleImpacted) {
    return null;
  }
  return (
    <Alert severity="warning">
      <AlertTitle>{t('hiring-dashboard-interviewers:interviewers.roleChangeAlert.title')}</AlertTitle>
      <Typography variant="body2">
        {t('hiring-dashboard-interviewers:interviewers.roleChangeAlert.body', {
          role: snakeCaseToInitCase(roleImpacted).toLowerCase(),
        })}
      </Typography>
    </Alert>
  );
};

export default RoleChangeAlert;
